<template>
  <el-card v-loading="loading" shadow="never">
    <slot slot="header"></slot>
    <div ref="chartDom" style="height: 100%" />
  </el-card>
</template>

<script>
let echarts = require('echarts')
let elementResizeDetectorMaker = require("element-resize-detector")
export default {
  data () {
    return {
      loading: false
    }
  },
  props: {
    params: { type: Object, default: () => { return {} } }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      if (this.loading) { return }
      this.loading = true
      this.$apis.trend.groupMonth(this.params).then(res => {
        this.drawChart(res)
      }).finally(() => {
        this.loading = false
      })
    },
    drawChart (source) {
      const that = this
      let keys = []
      source.data.map(m => {
        keys = [...new Set([...keys, ...Object.keys(m.value)])]
      })

      let colors = [
        ['rgba(0, 221, 255)', 'rgba(77, 119, 255)'],
        ['rgba(255, 191, 0)', 'rgba(224, 62, 76)'],
        ['rgba(255, 0, 135)', 'rgba(135, 0, 157)'],
      ]

      let option = {
        color: colors.map(x => x[0]),
        title: {
          text: `交易总额 ￥${source.total}万元`,
          subtext: `${this.params.category || "全部分类"} ${this.params.region || "全部地区"}`
        },
        grid: {
          left: 50,
          top: 80,
          right: 30,
          bottom: 20
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: source.data.map(row => { return row.name })
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {
          trigger: 'axis'
        },
        series: keys.map((m, i) => {
          return {
            type: 'line',
            name: m,
            stack: 'Total',
            data: source.data.map(row => { return row.value[m] || 0 }),
            smooth: true,
            showSymbol: false,
            emphasis: {
              focus: 'series'
            },
            lineStyle: {
              width: 0
            },
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: colors[i][0]
                },
                {
                  offset: 1,
                  color: colors[i][1]
                }
              ])
            },
          }
        })
      }
      const dom = that.$refs['chartDom']
      if (dom) {
        let chart = echarts.getInstanceByDom(dom)
        if (chart == null) {
          chart = echarts.init(dom)
          // 点击事件
          chart.on('click', function (params) {
            that.$router.push({ path: "detail", query: { ...that.params, dealtime: [params.name, params.name] } })
          })
          //响应刷新
          elementResizeDetectorMaker().listenTo(dom, function () {
            chart.resize()
          })
        }
        chart.setOption(option)
      }
    }
  }
}
</script>
